import AbstractModule from './AbstractModule';
import {$document} from "../utils/environment";

export default class extends AbstractModule {
    /**
     * Constructeur.
     * @return {void}
     */
    constructor(options) {
        super(options);

        setTimeout(() => {
            this.init();
        }, 2100);
    }

    /**
     * Initialisation.
     *
     * @return {void}
     */
    init() {
        if (window.location.hash) {
            if ($(window.location.hash).length) {
                $document.trigger({
                    type  : 'goTo.Scroll',
                    target: window.location.hash,
                    offset: -120
                });
            }
        }
    }

    /**
     * Destructeur.
     *
     * @return {void}
     */
    destroy() {
    }
}
